module.exports = __webpack_public_path__ + "static/media/Kakuna_gaussian2.df5a160a.png";